module.exports = __webpack_public_path__ + "static/media/mfrm-bnb.962d0395.png";